{
  "version": 1,
  "asset_id": "fbfa978b-b31a-40ca-b3f8-a9edc7e8cf03",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/fbfa978b-b31a-40ca-b3f8-a9edc7e8cf03/capital-pro-services-poster.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/fbfa978b-b31a-40ca-b3f8-a9edc7e8cf03/capital-pro-services-poster.webp",
  "original_filename": "capital-pro-services-poster.webp",
  "size": 76986,
  "content_type": "image/webp",
  "created_at": "2026-08-01T22:43:49Z"
}
